import { ProjectData } from '@/types/project';

export const initialProjectData: ProjectData = {
  details: {
    projectName: '',
    clientName: '',
    projectStartDate: null,
    projectEndDate: null,
    reportingPeriodStart: null,
    reportingPeriodEnd: null,
  },
  value: {
    contractValue: null,
    approvedVariations: null,
    unapprovedVariations: null,
    invoicedToDate: null,
    retention: null,
    forecastedRevenue: null,
    budgetedRevenue: null,
  },
  costs: {
    labour: { toDate: null, forecast: null, budgeted: null, comment: '' },
    materials: { toDate: null, forecast: null, budgeted: null, comment: '' },
    overheads: { toDate: null, forecast: null, budgeted: null, comment: '' },
    plant: { toDate: null, forecast: null, budgeted: null, comment: '' },
    staff: { toDate: null, forecast: null, budgeted: null, comment: '' },
    subcontractor: { toDate: null, forecast: null, budgeted: null, comment: '' },
    budgetedCosts: null,
  },
};